import React, { Component, useState, useEffect } from 'react';
import './spin.css';
import pointer from "../../assets/pointer.png";

let colorSet = [{ color: '' }, { color: '' }, { color: '' }, { color: '' }];

export function CustomWheel({ prizeList, ...props }) {
	let [loading, setLoading] = useState(false);
	let [winner, setWinner] = useState();
	let [wheelClass, setWheelClass] = useState('WheelWrapper__Circle');

	const startRotation = () => {
		let winnerValue;
		let winnerId;
		prizeList.forEach((item, i) => {
			if (item.winner) {
				winnerValue = i;
				winnerId = item.id;
				sessionStorage.setItem('winnerID', winnerId);
			}
		});

		let timer = 4000 - ((winnerValue - 1) * 1000) / prizeList.length;
		setWheelClass('WheelWrapper__Circle start-rotate');
		setTimeout(() => {
			setWheelClass('WheelWrapper__Circle start-rotate stop-rotate');
			if (typeof props.postSpinHandler === 'function') {
				props.postSpinHandler();
			}
		}, timer);
	};

	useEffect(() => {
		console.log({ props });
		if (props.rotating) {
			startRotation();
		}
	}, [props.rotating]);

	if (loading) {
		return <div>Loading...</div>;
	}

	return (
		<div className="WheelWrapper">
			<div className="CircleBorder">
				<div className={wheelClass}>
					{prizeList &&
						prizeList.map((prize, i) => {
							return (
								<div
									key={i}
									className="WheelWrapper__Circle__Segment"
									style={{
										transform: `rotate(${45 + (i + 1) * 90}deg) skewY(-${
											0 * prizeList.length
										}deg)`,
										background: ` url(${colorSet[i].color})`,
										backgroundPosition: '50%',
									}}
								>
									{prize?.image ? (
										<img
											src={prize.image}
											alt=""
											className="WheelWrapper__Circle__Segment--Image"
											style={{
												transform: `skewY(${
													3.6 * prizeList.length
												}deg) rotate(36deg)`,
											}}
										/>
									) : (
										' '
									)}
									{/* <div  className="WheelWrapper__Circle__Segment--Text" style={{ transform: `skewY(${3.6*prizeList.length}deg) rotate(36deg)`,color: i%2!=0 ? "#FDEF9A":"#650101",bottom:i%2!=0 ? "21%":"",left:i%2!=0 ? "17%":""}}>{prize.spinText}</div> */}
								</div>
							);
						})}
				</div>
				{/* <img className="WheelWrapper--Center" src="https://cdn-wl-assets.classplus.co/production/single/learn/732ab659-a6c3-4a86-b31a-1d925c6fcd47.png" alt="" /> */}
				<img className="WheelWrapperPointer" src='https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/spin-circle-pointer.png' alt="tringleCorner"
				/>
			</div>
		</div>
	);
}

export default CustomWheel;
